// extracted by mini-css-extract-plugin
export default {"download-image":"PlatformStoreImage_download-image__K+ek4"};